export default __webpack_public_path__ + "static/media/min.ed1fdd05.svg";